/*
  Arrow navigation for the GPHG "Every Watch Competing" sliders.

  The markup lives in the blog article body, where Shopify's rich text editor
  strips <script> tags on save — so the behaviour has to live in the theme.
  Structure it expects, repeated once per category:

    .gphg-static__slider
      button.gphg-static__arrow--previous
      .gphg-static__viewport   (overflow-x: auto, scroll-behavior: smooth)
        .gphg-static__grid
          article.gphg-static__card
      button.gphg-static__arrow--next
*/
(function () {
  var SLIDER = '.gphg-static__slider';
  var EDGE = 2; // px tolerance for sub-pixel scroll positions

  function step(viewport) {
    // One page = the visible width, which is an exact number of columns.
    // Fall back to a single card if the viewport hasn't been laid out yet.
    if (viewport.clientWidth > 0) return viewport.clientWidth;
    var card = viewport.querySelector('.gphg-static__card');
    return card ? card.offsetWidth : 300;
  }

  function setup(slider) {
    if (slider.dataset.gphgReady) return;

    var viewport = slider.querySelector('.gphg-static__viewport');
    var previous = slider.querySelector('.gphg-static__arrow--previous');
    var next = slider.querySelector('.gphg-static__arrow--next');
    if (!viewport || !previous || !next) return;

    slider.dataset.gphgReady = 'true';

    function refresh() {
      var max = viewport.scrollWidth - viewport.clientWidth;
      previous.disabled = viewport.scrollLeft <= EDGE;
      next.disabled = viewport.scrollLeft >= max - EDGE;
    }

    // No `behavior` here on purpose: it defers to the CSS `scroll-behavior`,
    // which the stylesheet already drops to `auto` under prefers-reduced-motion.
    previous.addEventListener('click', function () {
      viewport.scrollBy({ left: -step(viewport) });
    });
    next.addEventListener('click', function () {
      viewport.scrollBy({ left: step(viewport) });
    });

    var pending = false;
    viewport.addEventListener(
      'scroll',
      function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          refresh();
        });
      },
      { passive: true }
    );

    // Lazy-loaded card images change scrollWidth after first paint.
    if (window.ResizeObserver) {
      new ResizeObserver(refresh).observe(viewport.querySelector('.gphg-static__grid') || viewport);
    } else {
      window.addEventListener('resize', refresh);
    }

    refresh();
  }

  function init() {
    document.querySelectorAll(SLIDER).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Images and third-party embeds can shift layout after DOMContentLoaded;
  // setup() is idempotent, so a second pass is free.
  window.addEventListener('load', init);
})();
